module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.login
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "password",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")])]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Sign In\n        ")])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-card-colo"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Sign In")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a2c83d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailPassword/LoginForm.vue
// module id = 419
// module chunks = 1